import React, { useState } from 'react';

import { useRouter } from 'next/router';
import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import NewThemeIcon from '../NewThemeIcon/NewThemeIcon';
import SpinningLoader from '../SpinningLoader/SpinningLoader';

const BundleDiscountWrapper = styled.div`
  display: flex;
  position: relative;
`;

const DiscountWrapper = styled.div`
  display: flex;
  border: 1px solid ${({ theme }) => theme.colors.gunmetal};
  padding: ${({ theme }) => theme.spacing.small}px;
  margin: 0 ${({ theme }) => theme.spacing.small}px;
  cursor: pointer;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const PromoLabelWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.lavender200};
  padding: 2px ${({ theme }) => theme.spacing.tiny}px;
  width: fit-content;
  margin-bottom: 10px;
`;

const BundleLabelWrapper = styled.div`
  ${({ theme }) => theme.paragraph.variants.paragraph4Uppercase.textStyles};
  display: flex;
  margin: 0 auto;
`;

const BundleLabel = styled.span`
  ${({ theme }) => theme.subHeader.variants.subHeading4Uppercase.textStyles};
`;

const StyledNewThemeIcon = styled(NewThemeIcon)`
  margin: auto;
`;

type BasketItemBundleDiscountProps = {
  promoLabel: string;
  missingBundleItems: number;
  redirectUrl: string;
};
export const BasketItemBundleDiscount = ({
  promoLabel,
  missingBundleItems,
  redirectUrl,
}: BasketItemBundleDiscountProps) => {
  const router = useRouter();
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);
  const redirectToBundlePage = () => {
    setShowLoadingIndicator(true);
    try {
      if (redirectUrl) {
        router.push(redirectUrl);
      }
    } catch (error) {
      setShowLoadingIndicator(false);
    }
  };

  return (
    <BundleDiscountWrapper>
      {showLoadingIndicator && (
        <SpinningLoader
          isLoading
          height={24}
          width={24}
          shouldFadeBackground
          color="#1c1b1f"
        />
      )}
      <DiscountWrapper
        onClick={redirectToBundlePage}
        data-autotag="bundle-upsell-click"
        data-qa-automation="BundleUpsellClick"
      >
        <TextWrapper>
          <PromoLabelWrapper>{promoLabel}</PromoLabelWrapper>
          <BundleLabelWrapper>
            <div>
              {missingBundleItems === 1 ? (
                <FormattedMessage
                  defaultMessage="Add one more item to complete your"
                  id="global_checkout.add_more_items_single"
                />
              ) : (
                <FormattedMessage
                  defaultMessage="Add {missingBundleItems} more items to complete your"
                  id="global_checkout.add_more_items_plural"
                  values={{
                    missingBundleItems,
                  }}
                />
              )}
              &nbsp;
              <BundleLabel>
                <FormattedMessage
                  defaultMessage="{promoLabel} Bundle"
                  id="global_checkout.bundle_label"
                  values={{
                    promoLabel,
                  }}
                />
              </BundleLabel>
            </div>
          </BundleLabelWrapper>
        </TextWrapper>
        <StyledNewThemeIcon type="caretRight" size={24} />
      </DiscountWrapper>
    </BundleDiscountWrapper>
  );
};
